﻿<template>
    <aunoa-nav-item
        id="selectFluidNavItem"
        :drop-direction="dropDirection"
        :drop-menu-class="dropMenuClass"
        :header-text="t('Aunoa.Layout.Title')"
        :icon="icon[fluid]"
    >
        <li>
            <div class="px-3 pb-3 text-muted small">
                <span class="fst-italic" v-text="t('Aunoa.Layout.Remark',{'size':'xl'})" />
            </div>
        </li>
        <aunoa-dropdown-check-item
            :checked="fluid==='auto'"
            :text="t('Aunoa.Layout.Auto')"
            :end-icon="icon['auto']"
            @click="set('auto')"
        />
        <aunoa-dropdown-divider />
        <aunoa-dropdown-check-item
            :checked="fluid==='full-width'"
            :text="t('Aunoa.Layout.FullWidth')"
            :end-icon="icon['full-width']"
            @click="set('full-width')"
        />
        <aunoa-dropdown-check-item
            :checked="fluid==='boxed'"
            :text="t('Aunoa.Layout.Boxed')"
            :end-icon="icon['boxed']"
            @click="set('boxed')"
        />
    </aunoa-nav-item>
</template>

<script lang="ts">

import {defineComponent} from "vue";
import AunoaSelectNavItemMixin from "../mixins/AunoaSelectNavItemMixin";
import AunoaDropdownCheckItem from "./dropdown/AunoaDropdownCheckItem.vue";
import AunoaDropdownDivider from "./dropdown/AunoaDropdownDivider.vue";
import AunoaNavItem from "./nav/AunoaNavItem.vue";
import {useAunoaI18n} from "../utils/useAunoaI18n";

export default defineComponent({
    name: "AunoaSelectFluidNavItem",
    mixins: [AunoaSelectNavItemMixin],
    components: {
        AunoaDropdownCheckItem,
        AunoaDropdownDivider,
        AunoaNavItem
    },
    props: {
        fluid: {
            type: String,
            required: true
        }
    },
    emits: ["update:fluid"],
    setup(props, {emit}) {

        const {t} = useAunoaI18n();
        const set = (value: string) => emit('update:fluid', value);

        const icon : {[key: string]:string} = {
            "auto": "fas fa-diamond",
            "full-width": "fad fa-rectangle-wide",
            "boxed": "fad fa-square"
        }

        return {
            t,
            set,
            icon
        }
    }
});

</script>

